import CryptoJS from "crypto-js";

const encryptionKey = process.env.REACT_APP_USER_INFO_SECRET;

export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), encryptionKey).toString();
};

export const decryptData = (cipherText) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, encryptionKey);

    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } catch (error) {
    console.error("Decryption error:", error);

    return null;
  }
};
